import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88c3c426&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c3c426')) {
      api.createRecord('88c3c426', component.options)
    } else {
      api.reload('88c3c426', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88c3c426&", function () {
      api.rerender('88c3c426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pain008/components_Traitement_Données/index.vue"
export default component.exports